/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_All_LanguagesInputs */



/**
* | output |
* | --- |
* | "All languages" |
*
* @param {Community_All_LanguagesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_all_languages = /** @type {((inputs?: Community_All_LanguagesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_All_LanguagesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les langues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los idiomas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os idiomas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le lingue")
	return /** @type {LocalizedString} */ ("All languages")
});